(() => {
  'use strict';
  const root = document.querySelector('[data-cax]');
  if (!root) return;
  const q = (s, r = root) => r.querySelector(s);
  const qa = (s, r = root) => [...r.querySelectorAll(s)];
  const form = q('[data-cax-form]');
  const scenes = qa('[data-cax-scene]');
  const texts = scenes.map(s => q('[data-cax-text]', s));
  const files = scenes.map(s => q('[data-cax-file]', s));
  const names = q('[name="properties[Names to show]"]');
  const email = q('[name="properties[Delivery email]"]');
  const errorBox = q('[data-cax-error]');
  const customId = Number(root.dataset.custom);
  const customPrice = Number(root.dataset.customPrice);
  const base = root.dataset.root;
  const MAX = 20 * 1024 * 1024;
  const emailOk = () => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim());
  const money = cents => '$' + (cents / 100).toFixed(2);
  const showError = msg => { errorBox.textContent = msg; errorBox.hidden = false; };

  // Projector choice: preselect from ?p= (links from projector pages).
  const pick = new URLSearchParams(location.search).get('p');
  const radios = qa('[name="cax-projector"]');
  const preset = radios.find(r => r.value === pick);
  if (preset) preset.checked = true;
  const selected = () => radios.find(r => r.checked);
  const projectorVariant = () => {
    const card = selected()?.closest('.cax-proj__card');
    const opt = card && q('[data-cax-plug]', card)?.selectedOptions[0];
    return opt ? { id: Number(opt.value), price: Number(opt.dataset.price) } : null;
  };

  const refresh = () => {
    let described = 0, photos = 0;
    scenes.forEach((s, i) => {
      const t = texts[i].value.trim() !== '', p = files[i].files.length > 0;
      if (t) described++;
      if (p) photos++;
      s.classList.toggle('is-filled', t || p);
    });
    q('[data-cax-count]').textContent = described;
    q('[data-cax-photos]').textContent = photos;
    const set = (k, ok) => q(`[data-cax-check="${k}"]`).classList.toggle('is-ok', ok);
    set('names', names.value.trim() !== '');
    set('scenes', described === 6);
    set('photos', photos === 6);
    set('email', emailOk());

    const radio = selected(), pv = projectorVariant();
    q('[data-cax-line-proj]').hidden = !pv;
    q('[data-cax-line-gift]').hidden = !pv || !radio.dataset.gift;
    if (pv) {
      q('[data-cax-proj-name]').textContent = radio.closest('.cax-proj__card').querySelector('b').textContent + ' projector';
      q('[data-cax-proj-total]').textContent = money(pv.price);
    }
    const total = money(customPrice + (pv ? pv.price : 0));
    q('[data-cax-total]').textContent = total;
    q('[data-cax-sticky-total]').textContent = total;
    qa('[data-cax-idea]').forEach(b => b.setAttribute('aria-pressed', String(texts.some(t => t.value.trim() === b.dataset.caxIdea))));
  };

  qa('[data-cax-idea]').forEach(btn => btn.addEventListener('click', () => {
    const text = btn.dataset.caxIdea;
    const existing = texts.find(t => t.value.trim() === text);
    if (existing) existing.value = '';
    else {
      const empty = texts.find(t => t.value.trim() === '');
      if (!empty) { showError('All 6 scenes are filled. Clear one to add this idea.'); return; }
      empty.value = text;
    }
    errorBox.hidden = true;
    refresh();
  }));

  files.forEach((input, i) => input.addEventListener('change', () => {
    const thumb = q('[data-cax-thumb]', scenes[i]);
    const label = q('[data-cax-file-label]', scenes[i]);
    if (input.files[0] && input.files[0].size > MAX) {
      input.value = '';
      showError('That photo is larger than 20 MB. Please choose a smaller one.');
    }
    thumb.hidden = !input.files[0];
    if (input.files[0]) thumb.src = URL.createObjectURL(input.files[0]);
    label.textContent = input.files[0] ? 'Change' : 'Photo';
    refresh();
  }));

  form.addEventListener('input', e => { e.target.classList?.remove('is-invalid'); refresh(); });
  form.addEventListener('change', refresh);

  const post = async (url, body, json) => {
    const res = await fetch(base + url, { method: 'POST', body: json ? JSON.stringify(body) : body, headers: json ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' } });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
    return data;
  };

  form.addEventListener('submit', async e => {
    e.preventDefault();
    const buyNow = e.submitter?.hasAttribute('data-cax-buy');
    const missing = [names, email].filter(el => el === email ? !emailOk() : !el.value.trim());
    if (missing.length) {
      missing.forEach(el => el.classList.add('is-invalid'));
      showError('Please add the names to show and your email so we know where to send your videos.');
      missing[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (!texts.some(t => t.value.trim())) {
      texts[0].classList.add('is-invalid');
      showError('Describe at least one scene, or tap any idea above.');
      texts[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    errorBox.hidden = true;
    const radio = selected(), family = radio.value, pv = projectorVariant();

    // Custom line carries the form; empty fields are skipped so the order stays clean.
    const data = new FormData();
    data.append('id', customId);
    data.append('quantity', 1);
    for (const [k, v] of new FormData(form)) {
      if (!k.startsWith('properties[')) continue;
      if (v instanceof File ? v.size > 0 : String(v).trim() !== '') data.append(k, v);
    }
    if (pv) data.append('properties[_animation_for]', family);

    const buttons = qa('button[type=submit]', form);
    buttons.forEach(b => b.setAttribute('aria-busy', 'true'));
    const label = e.submitter?.textContent;
    if (e.submitter) e.submitter.textContent = 'Uploading…';
    try {
      if (pv) {
        const items = [{ id: pv.id, quantity: 1 }];
        if (radio.dataset.gift) items.push({ id: Number(radio.dataset.gift), quantity: 1, properties: { _animation_for: family } });
        await post('cart/add.js', { items }, true);
      }
      await post('cart/add.js', data, false);
      location.assign(base + (buyNow ? 'checkout' : 'cart'));
    } catch (err) {
      showError(err.message);
      buttons.forEach(b => b.removeAttribute('aria-busy'));
      if (e.submitter) e.submitter.textContent = label;
    }
  });

  const sticky = q('[data-cax-sticky]');
  if (sticky && 'IntersectionObserver' in window && matchMedia('(max-width: 899px)').matches) {
    const seen = new Set();
    const io = new IntersectionObserver(entries => {
      entries.forEach(en => en.isIntersecting ? seen.add(en.target) : seen.delete(en.target));
      sticky.hidden = seen.size > 0;
    });
    [q('.cax-hero .cax-btn'), form].forEach(el => el && io.observe(el));
  }
  // Scene editor: a roomy sheet with a Done button, kept above the phone keyboard.
  const sheet = document.createElement('div');
  sheet.className = 'cax-sheet';
  sheet.hidden = true;
  sheet.innerHTML = `<div class="cax-sheet__backdrop" data-close></div>
    <div class="cax-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="cax-sheet-title">
      <div class="cax-sheet__head"><span class="cax-sheet__num"></span><b id="cax-sheet-title"></b><button type="button" class="cax-sheet__x" data-close aria-label="Close">×</button></div>
      <p class="cax-sheet__tip">Who is in it and what happens? Names, colors, a short greeting.</p>
      <textarea class="cax-sheet__text" maxlength="400" rows="6" placeholder="e.g. Our dog Max in a Santa hat pulls the sleigh over our house, then the sky says “Merry Christmas, the Millers!”"></textarea>
      <div class="cax-sheet__ideas"></div>
      <div class="cax-sheet__foot"><small><span data-count>0</span>/400</small><button type="button" class="cax-sheet__done">Done</button></div>
    </div>`;
  root.appendChild(sheet);
  const panel = q('.cax-sheet__panel', sheet);
  const editor = q('.cax-sheet__text', sheet);
  const counter = q('[data-count]', sheet);
  const ideaBox = q('.cax-sheet__ideas', sheet);
  qa('[data-cax-idea]').forEach(b => {
    const chip = document.createElement('button');
    chip.type = 'button';
    chip.textContent = '+ ' + b.querySelector('b').textContent;
    chip.addEventListener('click', () => { editor.value = b.dataset.caxIdea; counter.textContent = editor.value.length; editor.focus(); });
    ideaBox.appendChild(chip);
  });
  let target = null;
  const fit = () => {
    const vv = window.visualViewport;
    if (!vv) return;
    panel.style.bottom = Math.max(0, window.innerHeight - vv.height - vv.offsetTop) + 'px';
    panel.style.maxHeight = (vv.height - 12) + 'px';
  };
  const openSheet = ta => {
    target = ta;
    const n = texts.indexOf(ta) + 1;
    q('.cax-sheet__num', sheet).textContent = n;
    q('#cax-sheet-title', sheet).textContent = `Scene ${n}`;
    editor.value = ta.value;
    counter.textContent = editor.value.length;
    sheet.hidden = false;
    document.documentElement.classList.add('cax-lock');
    fit();
    editor.focus();
    editor.setSelectionRange(editor.value.length, editor.value.length);
  };
  const closeSheet = save => {
    if (!target) return;
    if (save) { target.value = editor.value.trim(); target.classList.remove('is-invalid'); }
    sheet.hidden = true;
    document.documentElement.classList.remove('cax-lock');
    target = null;
    refresh();
  };
  texts.forEach(ta => {
    ta.readOnly = true;
    ta.addEventListener('click', () => openSheet(ta));
    ta.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openSheet(ta); } });
  });
  editor.addEventListener('input', () => { counter.textContent = editor.value.length; });
  q('.cax-sheet__done', sheet).addEventListener('click', () => closeSheet(true));
  qa('[data-close]', sheet).forEach(el => el.addEventListener('click', () => closeSheet(true)));
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && target) closeSheet(true); });
  window.visualViewport?.addEventListener('resize', () => { if (target) fit(); });
  window.visualViewport?.addEventListener('scroll', () => { if (target) fit(); });

  if (preset && location.hash !== '#cax-builder') q('#cax-builder').scrollIntoView();
  refresh();
})();
